/**
 * 支付结果总线：Bridge push 与 resume reconcile 统一入口，供 useAppPayment 订阅。
 */

import log from "logbeacon";
import type { PaymentPurchaseSuccessData } from "./types";

export type PaymentOutcomeEvent =
  | {
      kind: "success";
      data: PaymentPurchaseSuccessData & { verified?: boolean };
      operationId?: string;
      source: "bridge-push" | "reconcile-replay" | "reconcile-fallback";
    }
  | {
      kind: "result";
      data: {
        success?: boolean;
        error?: unknown;
        productId?: string;
      };
      operationId?: string;
      source: "bridge-push" | "reconcile-replay" | "reconcile-fallback";
    };

type PaymentOutcomeListener = (event: PaymentOutcomeEvent) => void;

const listeners = new Set<PaymentOutcomeListener>();

/**
 * 订阅支付结果（成功 / 失败取消）。
 * 来源含原生 push、Outbox 重放、reconcile 兜底；返回取消订阅函数。
 */
export function subscribePaymentOutcomes(
  listener: PaymentOutcomeListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * 向所有订阅者广播支付结果。
 * 由 Bridge `on` 回调、reconcile 重放或状态兜底触发；`useAppPayment` 统一在此收敛。
 */
export function emitPaymentOutcome(event: PaymentOutcomeEvent): void {
  log.info("[paymentOutcomeBus] emit", {
    kind: event.kind,
    source: event.source,
    operationId: event.operationId,
    productId: event.data.productId,
    ...(event.kind === "result" ? { success: event.data.success } : {}),
  });
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch {
      // ignore listener errors
    }
  });
}
